import { render, staticRenderFns } from "./SdsIndexPage.vue?vue&type=template&id=7996fe43"
import script from "./SdsIndexPage.vue?vue&type=script&lang=ts"
export * from "./SdsIndexPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports